<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>一键志愿填报</span>
		</div>
		<section class="gaokao-content">
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>1</p>
							<span>信息校对</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>2</p>
							<span>选择填报批次</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>3</p>
							<span>填写志愿表</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>4</p>
							<span>生成志愿表</span>
						</div>
					</div>
				</li>
			</ul>
			<article class="volunteer-one">
				<div class="one-li">
					<p>{{ condition.cityName }}</p>
					<p>{{ condition.subject }}</p>
					<p>{{ condition.branch }}分</p>
					<p>本科批</p>
				</div>
				<div class="one-btn">
					<p @click="gouser()">下载PDF</p>
					<p @click="goNextc()">修改</p>
				</div>
			</article>
			<article class="volunteerD-con">
				<p class="volt-tit">模拟志愿表</p>
				<div class="volt-list">
					<div class="volt-ul" v-for="(item, index) in list" :key="index">
						<div class="volt-ul-tit">
							<p class="volt-tit01">{{ item.Text }}</p>
							<p class="volt-tit02">{{ item.CollegesName }}</p>
							<p class="volt-tit02">{{ item.EnrollmentArea }}</p>
							<p class="volt-tit03" v-if="item.CollegesType == 1">可冲击</p>
							<p class="volt-tit03" v-if="item.CollegesType == 2">较稳定</p>
							<p class="volt-tit03 tit-on" v-if="item.CollegesType == 3">保底</p>
						</div>
						<ul class="volt-li">
							<li v-for="(t, index) in item.MajorList" :key="index">
								<p class="volt-li-txt01">
									<span>{{ t.Name }}</span>
									<span>{{ t.Score }}</span>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</article>
		</section>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
	data() {
		return {
			tabeId: 0,
			condition: {},
			list: []
		};
	},
	// 加载
	created() {
		var that = this;
		var condition = Cookies.get('TBZYcondition');
		if (condition !== undefined) {
			that.condition = JSON.parse(condition);
			console.log(that.condition);
		}
		that.tabeId = that.$route.query.tabeId;
		console.log(that.tabeId);
		if (that.tabeId) {
			that.GetVoluntarilySchoolList();
		}
	},

	methods: {
		gouser() {
			this.$router.push('/report');
		},
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 获取列表
		GetVoluntarilySchoolList: function() {
			var that = this;

			that.$api.HtppRequest(
				'SystemData/GetVoluntarilySchoolList?tabeId=' + that.tabeId,
				'GET',
				{},
				function(res) {
					console.log('获取', res);
					if (res.flag) {
						res.list.map(item => {
							if (item.CollegesId > 0) {
								that.list.push(item);
							}
						});
						console.log(that.list);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 填报志愿
		goNextc() {
			this.$router.push('/volunteerc');
		}
	}
};
</script>

<style scoped>
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
.gkTest-step {
	padding: 40px;
}
/* volunteer-one */
.volunteer-one {
	width: 100%;
	height: auto;
	background-color: #f7f7f7;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 40px;
	margin-bottom: 40px;
}
.one-li {
	display: flex;
	align-items: center;
}
.one-li p {
	width: 100px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 15px;
	color: #fff;
	border-radius: 5px;
	background-color: #e7bb7c;
	margin: 0 20px;
}
.one-btn {
	display: flex;
	align-items: center;
}
.one-btn p {
	width: 120px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 15px;
	border-radius: 5px;
	cursor: pointer;
	margin: 0 20px;
}
.one-btn p:first-child {
	color: #333;
	background-color: #ccdde3;
}
.one-btn p:last-child {
	color: #fff;
	background-color: #333;
}

/* volunteerD-con */
.volunteerD-con {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.volt-tit {
	width: 400px;
	height: 60px;
	text-align: center;
	line-height: 60px;
	font-size: 16px;
	color: #333;
	background-color: #eaeaea;
	margin: 0 auto;
}
.volt-list {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.volt-ul {
	width: 100%;
	height: auto;
	border-bottom: 1px solid #eee;
	margin-bottom: 20px;
}
.volt-ul-tit {
	display: flex;
	align-items: center;
}
.volt-tit01 {
	width: 100px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background-color: #333;
	font-size: 14px;
	color: #fff;
	border-radius: 4px;
	margin-right: 10px;
}
.volt-tit02 {
	font-size: 14px;
	color: #333;
	padding: 0 10px;
}
.volt-tit03 {
	width: 75px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	font-size: 14px;
	color: #ff3327;
	background-color: #fdc6c3;
	border-radius: 4px;
	margin-left: 10px;
}
.tit-on {
	background-color: #b4e2cd;
	color: #059151;
}
.volt-li {
	width: 100%;
	height: auto;
	margin-top: 20px;
	display: flex;
	flex-wrap: wrap;
}
.volt-li li {
	width: 32%;
	height: auto;
	background-color: #f7f7f7;
	margin-right: 20px;
	margin-bottom: 20px;
	padding: 15px 20px;
	position: relative;
}
.volt-li li:nth-child(3n + 3) {
	margin-right: 0px;
}
.volt-li-txt01 {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 15px;
}
.volt-li-txt01 span {
	font-size: 15px;
	color: #999;
}
.volt-li-txt01 span:last-child {
	color: #333;
}
.volt-li-txt02 {
	width: 100%;
	font-size: 15px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
}
.volt-more {
	position: absolute;
	width: 100%;
	min-height: 85px;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.7);
	padding: 20px;
	font-size: 15px;
	color: #fff;
	display: none;
}
.volt-li li:hover .volt-more {
	display: block;
}
</style>
